// extracted by mini-css-extract-plugin
export default {"container":"Header_container__QUeAV","menu":"Header_menu__K8bBY","sidebarToggler":"Header_sidebarToggler__UUMaN"};